import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormArray } from '@angular/forms';
import { Group } from '../../models/group';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {
  @Input() inputForm: FormGroup;
  @Input() groupList: Group[];

  constructor() { }

  ngOnInit() {
    this.GroupsUpdated.setValue(JSON.parse(JSON.stringify(this.Groups.value)));
  }

  onChanges() {
    this.GroupsUpdated.markAsDirty();
  }

  get Tabs() {
    return this.inputForm.get('Tabs') as FormArray;
  }

  get GroupsUpdated() {
    return this.inputForm.get('GroupsUpdated');
  }

  get Groups() {
    return this.inputForm.get('Groups');
  }

  get Status() {
    return this.inputForm.get('Status');
  }

  get CreatedDate() {
    return this.inputForm.get('CreatedDate');
  }

  get LastModifiedDate() {
    return this.inputForm.get('LastModifiedDate');
  }
}
